<div
  class="search"
  [class.search--open]="openSearch"
  (keydown.arrowup)="arrowNavigationListener('up', $event)"
  (keydown.arrowleft)="arrowNavigationListener('left', $event)"
  (keydown.arrowdown)="arrowNavigationListener('down', $event)"
  (keydown.arrowright)="arrowNavigationListener('right', $event)"
  (keyup.enter)="openLinkArrowSearch()">

  <!-- Expandable Search Container -->
  <div class="search__container" [class.search__container--expanded]="openSearch">
    <div class="search__bar">
      <form class="search__form" autocomplete="off">
        <img class="search__icon" src="assets/icons/header/search-icon.svg" alt="Search">
        <input
          #search
          class="search__input"
          type="text"
          placeholder="Search"
          [(ngModel)]="searchValue"
          name="search"
          (keydown.enter)="compareToTicker()"
          (focus)="blurSearchResults = false"
          (ngModelChange)="onSearchChange($event)">
        <button type="button" class="search__clear" (click)="clearSearchTerm()" aria-label="Clear search">
          <img class="search__clear-icon" src="assets/icons/cancel-icon-slim.svg" alt="Clear">
        </button>
      </form>
    </div>

    <!-- Search Results -->
    <div class="search__results" *ngIf="companyList.length > 0 || productList.length > 0 || indicationsList.length > 0">
      <div class="search__results-inner" [class.search__results-inner--hidden]="blurSearchResults">
        <ng-container
          *ngTemplateOutlet="resultSection; context: {
            title: 'COMPANY',
            items: companyList,
            columnIndex: 0,
            routePrefix: '/company',
            showCompanyDetails: true
          }">
        </ng-container>

        <ng-container
          *ngTemplateOutlet="resultSection; context: {
            title: 'INDICATION',
            items: indicationsList,
            columnIndex: 1,
            routePrefix: '/indications',
            showCompanyDetails: false
          }">
        </ng-container>

        <ng-container
          *ngTemplateOutlet="resultSection; context: {
            title: 'PRODUCT',
            items: productList,
            columnIndex: 2,
            routePrefix: '/product',
            showCompanyDetails: false
          }">
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Search Toggle Button -->
  <button
    type="button"
    class="search__toggle"
    (click)="onToggleClick($event)"
    aria-label="Toggle search">
    <rms-hover-icon
      *ngIf="!openSearch"
      [iconId]="SEARCH_BUTTON_ID"
      [staticIconSVG]="'assets/icons/header/search-icon.svg'"
      [hoverIconSVG]="'assets/icons/header/search-icon-bold.svg'"
      [iconHeight]="'19'">
    </rms-hover-icon>
    <rms-hover-icon
      *ngIf="openSearch"
      [staticIconSVG]="'assets/icons/header/arrow-right-icon.svg'"
      [hoverIconSVG]="'assets/icons/header/arrow-right-icon-bold.svg'"
      [iconHeight]="'19'">
    </rms-hover-icon>
  </button>
</div>

<!-- Template for search result sections -->
<ng-template
  #resultSection
  let-title="title"
  let-items="items"
  let-columnIndex="columnIndex"
  let-routePrefix="routePrefix"
  let-showCompanyDetails="showCompanyDetails">
  <div class="search__result-section">
    <h2 class="search__result-heading">{{ title }}</h2>
    <p class="search__no-result" *ngIf="!items.length">No {{ title | lowercase }} results</p>
    <ul class="search__result-list">
      <li
        *ngFor="let item of items; let i = index"
        class="search__result-item"
        [class.search__result-item--active]="arrowNavPosition.selectedColumn === columnIndex && arrowNavPosition.selectedRow === i">
        <a
          class="search__result-link"
          [target]="resultLinkTarget"
          [routerLink]="[routePrefix, item.id]"
          (click)="closeQuickSearch()">
          <span [innerHTML]="item.nameSelected"></span>
          <ng-container *ngIf="showCompanyDetails">
            <span class="search__badge search__badge--acquired" *ngIf="item.adquiredById">Acquired</span>
            <span class="search__badge search__badge--inactive" *ngIf="!item.active">Inactive</span>
            <span class="search__ticker">{{ item.isPrivate ? 'PRIVATE' : item.ticker }}</span>
          </ng-container>
        </a>
      </li>
    </ul>
  </div>
</ng-template>
